import { yupResolver } from "@hookform/resolvers/yup";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  LayoutNodeInput,
  Product,
} from "@towersystems/roam-common/lib/generated-types";
import { FormProvider, useForm } from "react-hook-form";
import { ModalCloseButton } from "@towersystems/roam-common-native";
import { ProductListScreen } from "../../../../components/ProductListScreen";
import { ProductListScreenContext } from "../../../../components/ProductListScreen/context";
import { EditProductQuickKeyRootParamList } from "../../../../types";
import { useEditTile } from "../../../../utilities/layout";
import {
  defaultLayoutNodeInputValues,
  productNodeInputSchema,
} from "../../../../utilities/layout/constants";
import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import { normalizeSelectedValues } from "../../../../utilities/transforms";
import { EditProductQuickKeyScreen } from "../EditProductQuickKeyScreen";
import ProductModel from "../../../../utilities/data/model/Product";
import { ListFilterProvider } from "../../../../utilities/list-filter/use-list-filter-context";
import { useListFilter } from "../../../../utilities/list-filter";
import { ProductsFilterValues } from "../../../products/types";
import { ProductListFilterRootScreen } from "../../../products/screens/ProductListFilterRootScreen";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { GenerateAiIconRootScreen } from "../GenerateAiIconScreens";
import { GenerateIconScreenContext } from "../GenerateAiIconScreens/common";
import { ColorPickerScreen } from "../../components/ColorPickerScreen/ColorPickerScreen";

export type EditProductQuickKeyRootScreenProps = NativeStackScreenProps<
  EditProductQuickKeyRootParamList,
  "EditProductQuickKeyScreen"
>;

export function EditProductQuickKeyRootScreen() {
  const Stack = createStackHeaderNavigator<EditProductQuickKeyRootParamList>();

  const filterContext = useListFilter<ProductsFilterValues>({
    defaultValues: {
      supplierIds: [],
      categoryIds: [],
      departmentIds: [],
      notRetailerProduct: false,
      isMainProduct: false,
    },
  });

  const { item } = useEditTile();

  console.log(
    "Editing product quick key:",
    item,
    defaultLayoutNodeInputValues,
    normalizeSelectedValues(defaultLayoutNodeInputValues, item?.config)
  );

  const methods = useForm<LayoutNodeInput>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: normalizeSelectedValues(
      defaultLayoutNodeInputValues,
      item?.config
    ),
    resolver: yupResolver(productNodeInputSchema),
  });

  const { setValue } = methods;

  function handleProductSelect(product: Product | ProductModel) {
    setValue("productId", product.id, {
      shouldDirty: true,
      shouldValidate: true,
    });
  }

  return (
    <GenerateIconScreenContext.Provider
      value={{
        onSubmit: async (base64Image: string) => {
          const time = new Date().getTime();
          const id = `${time}-${Math.floor(Math.random() * 1000)}`;

          // Pass the generated icon back to the previous screen
          const name = `key-icon-${id}.png`;
          setValue(
            "base64Image",
            {
              base64: base64Image,
              imageName: name,
            },
            {
              shouldDirty: true,
              shouldValidate: true,
            }
          );
        },
      }}
    >
      <ListFilterProvider {...filterContext}>
        <FormProvider {...methods}>
          <ProductListScreenContext.Provider
            value={{
              onSelect: handleProductSelect,
            }}
          >
            <Stack.Navigator>
              <Stack.Group
                screenOptions={{
                  animationEnabled: true,
                  headerShown: false,
                  title: "",
                  cardStyleInterpolator:
                    CardStyleInterpolators.forHorizontalIOS,
                }}
              >
                <Stack.Screen
                  name="EditProductQuickKeyScreen"
                  component={EditProductQuickKeyScreen}
                  options={{
                    headerShown: true,
                    headerLeft: () => <ModalCloseButton type="Cancel" />,
                  }}
                />
                <Stack.Group
                  screenOptions={{
                    animationEnabled: true,
                    headerShown: true,
                    headerLeft: () => <ModalCloseButton type="Back" />,
                  }}
                >
                  <Stack.Screen
                    name="ProductListScreen"
                    component={ProductListScreen}
                    options={{ title: "Search Product List" }}
                  />
                  <Stack.Screen
                    name="GenerateAiIconRootScreen"
                    component={GenerateAiIconRootScreen}
                    options={{
                      title: "",
                      headerShown: false,
                    }}
                  />
                  <Stack.Screen
                    name="ColorPickerScreen"
                    component={ColorPickerScreen}
                    options={{
                      title: "",
                    }}
                  />
                </Stack.Group>
              </Stack.Group>
              <Stack.Group
                screenOptions={{
                  headerShown: false,
                  presentation: "modal",
                }}
              >
                <Stack.Screen
                  name="ProductListFilterRootScreen"
                  component={ProductListFilterRootScreen}
                />
              </Stack.Group>
            </Stack.Navigator>
          </ProductListScreenContext.Provider>
        </FormProvider>
      </ListFilterProvider>
    </GenerateIconScreenContext.Provider>
  );
}
